import clientAuth from "../clientAuth";

export default {
  index: (year) => clientAuth.get(`utilization/utiliz_index?year=${year}`),
  
  
};